<template>
  <div class="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
    <img src="/images/logo.mark.png" alt="Credsy" class="mb-8 h-12 w-auto" width="48" height="48" />
    <p class="mb-3 text-lg font-semibold text-blue-700">{{ statusCode }}</p>
    <h1 class="mb-4 text-3xl font-bold text-gray-900 sm:text-4xl">{{ heading }}</h1>
    <p class="mb-8 max-w-md text-gray-500">{{ description }}</p>
    <a
      href="/"
      class="inline-flex items-center rounded-full bg-blue-600 px-6 py-3 font-medium text-white transition-colors hover:bg-blue-700"
      @click.prevent="handleBackHome"
    >
      Back to home
    </a>
  </div>
</template>

<script setup lang="ts">
// NOTE: no definePageMeta() here — it hoists its argument to module scope, and
// under the single-chunk (inlineDynamicImports) worker that runs any module-scope
// RNG at worker init, which workerd bans. Metadata is set via useHead only.
const props = defineProps<{
  error?: { statusCode?: number; statusMessage?: string; message?: string }
}>()

const statusCode = computed(() => props.error?.statusCode || 500)
const isNotFound = computed(() => statusCode.value === 404)
const heading = computed(() => (isNotFound.value ? 'Page not found' : 'Something went wrong'))
const description = computed(() =>
  isNotFound.value
    ? 'The page you’re looking for doesn’t exist or may have moved.'
    : 'An unexpected error occurred. Please try again in a moment.',
)

const handleBackHome = () => clearError({ redirect: '/' })

useHead({
  title: computed(() => `${statusCode.value} — Credsy`),
  htmlAttrs: { lang: 'en' },
  bodyAttrs: { class: 'bg-white' },
  meta: [{ name: 'robots', content: 'noindex' }],
})
</script>
